import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { MenuItem, Typography } from '@material-ui/core'
import { TextInput } from 'app/components/FormsyHelperComponent'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state'
import {
  Popover,
  Card,
  CardHeader,
  CardActions,
  CardContent,
} from '@material-ui/core'
import useStyles from './customFieldsStyle'
import {
  SOCIAL_PAGES,
  DEFAULT_SOCIAL_PAGE,
  TEXT,
  SOCIAL_INFORMATION,
} from './constants'
import { SelectFormsy } from '@fuse'
import CancelButton from 'app/components/buttons/CancelButton'
import PrimaryButton from 'app/components/buttons/PrimaryButton'

const CustomSocialForm = ({ newCustomDialogStyle, label, saveCustomLabel }) => {
  const styleClass = useStyles()
  const { formatMessage } = useIntl()

  const [customSocialField, setCustomSocialField] = useState({
    labelType: DEFAULT_SOCIAL_PAGE,
    label: DEFAULT_SOCIAL_PAGE,
    fieldType: TEXT,
  })
  const handleSaveData = () => {
    saveCustomLabel(customSocialField, SOCIAL_INFORMATION)
    setCustomSocialField({
      labelType: DEFAULT_SOCIAL_PAGE,
      label: DEFAULT_SOCIAL_PAGE,
      fieldType: TEXT,
    })
  }

  const isDisabled = () => {
    if (
      customSocialField.labelType === 'Other' &&
      !customSocialField.label.length > 0
    ) {
      return true
    } else {
      return false
    }
  }

  return (
    <div>
      <PopupState variant="popover" popupId="demo-popup-popover">
        {(popupState) => (
          <div style={{ position: 'relative' }}>
            <div
              className={newCustomDialogStyle}
              style={{ cursor: 'pointer' }}
              {...bindTrigger(popupState)}
            >
              <AddCircleOutlineIcon color="secondary" />
            </div>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Card className={styleClass.cardStyle}>
                <CardHeader
                  title={formatMessage({
                    id: 'crm.custom.field.add.social.information',
                  })}
                  className={styleClass.cardHeaderStyle}
                />
                <CardContent>
                  <div>
                    <SelectFormsy
                      className="w-full"
                      name={customSocialField.labelType}
                      label={formatMessage({
                        id: 'crm.custom.field.choose.social.media',
                      })}
                      value={customSocialField.labelType}
                      variant="standard"
                      onChange={(event) => {
                        setCustomSocialField({
                          ...customSocialField,
                          labelType: event.target.value,
                          label: event.target.value,
                        })
                      }}
                    >
                      {SOCIAL_PAGES.map((item, index) => (
                        <MenuItem key={index} value={item}>
                          <Typography>{item}</Typography>
                        </MenuItem>
                      ))}
                    </SelectFormsy>
                    {customSocialField.labelType === 'Other' && (
                      <div className={styleClass.fieldWrapper}>
                        <TextInput
                          margin="dense"
                          containerClassName="MuiFormControl-fullWidth"
                          labelId="Label Name"
                          placeholderId={formatMessage({
                            id: 'crm.custom.field.input.label.name',
                          })}
                          variant="standard"
                          fullWidth
                          name="customSocial"
                          onChange={(event) => {
                            setCustomSocialField({
                              ...customSocialField,
                              label: event.target.value,
                            })
                          }}
                        />
                      </div>
                    )}
                  </div>
                </CardContent>
                <CardActions className={styleClass.actionsWrapper}>
                  <CancelButton
                    className={styleClass.actionBtn}
                    onClick={() => {
                      popupState.setOpen(false)
                    }}
                  >
                    {formatMessage({ id: 'action.cancel' })}
                  </CancelButton>
                  <PrimaryButton
                    type="submit"
                    className={styleClass.actionBtn}
                    disabled={isDisabled()}
                    onClick={() => {
                      popupState.setOpen(false)
                      handleSaveData()
                    }}
                  >
                    {formatMessage({ id: 'action.ok' })}
                  </PrimaryButton>
                </CardActions>
              </Card>
            </Popover>
          </div>
        )}
      </PopupState>
    </div>
  )
}

export default CustomSocialForm
